module.exports = __webpack_public_path__ + "img/stadia_controller_opsz24.61ddaff0.svg";